import Axios from "axios";
import { ApiBaseUrl, SupplierPaymentUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  CreateNewPaymentRequest,
  GetLoansReadyForSettlementResponse,
  GetPaymentHistoryRequest,
  GetPaymentHistoryResponse,
  GetPaymentRequestInfoResponse,
  GetWalletInfoResponse,
  PaymentSettlementKeyRequest,
} from "../models/supplierPayment.model";

export const GetWalletInfo = (): Promise<GetWalletInfoResponse> => {
  return Axios.post<ApiResultModel<GetWalletInfoResponse>>(
    ApiBaseUrl + SupplierPaymentUrl + "/GetWalletInfo"
  ).then((result) => {
    return result.data.data;
  });
};

export const CreateNewPayment = (
  data: CreateNewPaymentRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierPaymentUrl + "/CreateNewPayment",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoansReadyForSettlement = (): Promise<GetLoansReadyForSettlementResponse[]> => {
  return Axios.post<ApiResultModel<GetLoansReadyForSettlementResponse[]>>(
    ApiBaseUrl + SupplierPaymentUrl + "/GetLoansReadyForSettlement"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPaymentHistory = async (
  data: GetPaymentHistoryRequest
): Promise<ApiResultModel<GetPaymentHistoryResponse[]>> => {
  return await Axios.post<ApiResultModel<GetPaymentHistoryResponse[]>>(
    ApiBaseUrl + SupplierPaymentUrl + "/GetPaymentHistory",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetInProgressPayments = (): Promise<GetPaymentHistoryResponse[]> => {
  return Axios.post<ApiResultModel<GetPaymentHistoryResponse[]>>(
    ApiBaseUrl + SupplierPaymentUrl + "/GetInProgressPayments"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetPaymentRequestInfo = async (
  data: PaymentSettlementKeyRequest
): Promise<GetPaymentRequestInfoResponse> => {
  return await Axios.post<ApiResultModel<GetPaymentRequestInfoResponse>>(
    ApiBaseUrl + SupplierPaymentUrl + "/GetPaymentRequestInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPaymentRequestExcelInfo = async (
  data: PaymentSettlementKeyRequest
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SupplierPaymentUrl + "/GetPaymentRequestExcelFile",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"پرونده های تسهیلات پذیرنده"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
